// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../../css-global/colors.scss\"","GrayDark":"#768d99","BlackLight":"#323c42","chartTitle":"ChartTitle-module--chartTitle--2fULB"};